import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i446267765__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Workflow", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i446267765__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("circle", {
      cx: "60",
      cy: "92",
      r: "16",
      style: {"fill":"none"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M60 68c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24m0 40c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16M38.33 124c-8.63 0-16.27 5.73-18.59 13.93L8.16 178.89l7.7 2.18 11.59-40.96c1.35-4.77 5.83-8.11 10.89-8.11H81.7c5.07 0 9.55 3.34 10.89 8.11l11.57 40.97 7.7-2.17-11.56-40.97C97.99 129.73 90.34 124 81.71 124zM163.59 45.73c-1.06 0-2.08.42-2.83 1.17l-16.42 16.44 5.66 5.65 9.59-9.6v5.44c0 6.72-2.62 13.04-7.39 17.79s-11.11 7.37-17.86 7.37-13.09-2.62-17.86-7.37l-5.65 5.67c6.28 6.26 14.63 9.71 23.51 9.71s17.23-3.45 23.51-9.71 9.74-14.59 9.74-23.45v-5.46l9.59 9.59 5.66-5.66-16.41-16.41a4 4 0 0 0-2.83-1.17ZM110.19 39.71c-6.28 6.26-9.74 14.59-9.74 23.45v3.47l-9.62-9.61-5.66 5.66 16.41 16.41c.78.78 1.8 1.17 2.83 1.17s2.04-.39 2.82-1.17l16.48-16.43-5.65-5.67-9.62 9.59v-3.42c0-6.72 2.62-13.04 7.39-17.79S126.94 38 133.69 38s13.09 2.62 17.86 7.37l5.65-5.67c-6.28-6.26-14.63-9.71-23.51-9.71s-17.23 3.45-23.51 9.71Z",
      class: "i446267765__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "personFlow"}) } }